// *********** A_HOME ***************************************
// *** a_home.jsx ***********
// *** autor: W de Paula / MVinfo
// *** data: 16/12/24 | 11h14
// ***********************************************************





import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import Swal from "sweetalert2";
// import apiaxios from "../../../../Services/apiaxios.js";
// import handleApiError from '../../../../Services/apiErrorHandler.js';
// import { encrypt, decrypt } from "../../../../Services/cryptoUtils.js";
import { a_getUserData } from "../../../../Services/a_userutils.js";
import { useCarregaDados } from "../../Hooks/a_usecarregadados.jsx";
import { AutoLogout } from "../../../../Services/autologout.js";
import { Container, Row, Col, Button } from 'react-bootstrap'; // Certifique-se de importar os componentes corretamente

import Menu from "../../Components/Menu/a_menu.jsx";
import MenuConfig from "../../Components/Menu/a_menuconfig.jsx";
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";

import './a_home.css';

function A_Home() {
    // verifica se os tokens estão presentes e não corrompidos/vencidos
    const tokenASW = localStorage.getItem("tokenasw"); // modificado pela linha abaixo 27/10/25w
    // const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenLG = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenLG) {
            AutoLogout();
        }
    }, [tokenASW]);

    const initialUserData = a_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId);
    // const [indEmpresa, setIndEmpresa] = useState(initialUserData.indEmpresa);
    const [emailValidado, setEmailValidado] = useState(initialUserData.emailValidado);
    const [validado, setvalidado] = useState(initialUserData.validado); // CPF/CNPJ validado =1 (se ainda não foi validado = 0)
    // const [tipoAtendimento] = useState(initialUserData.tipoAtendimento); // Usar setIdUsuario para atualizar o id_usuario
    // const [agendaFechada, setAgendaFechada] = useState(initialUserData.agenda_fechada);  // 0 = Aberta, 1 = Fechada
    // const [tipoAgenda, setTipoAgenda] = useState(initialUserData.tipoAgenda); // 0 = Global, 1 = Individual
    // const [lock, setLock] = useState(initialUserData.bloqueio);  // 0 = prestador liberado, 1 = prestador bloqueado por fim de contrato // linha acima
    // const [diasVencimentoContrato, setdiasVencimentoContrato] = useState(initialUserData.dias_FimContrato);  // receber a quantidade de dias que faltam pra encerrar o contrato 6/12/24w

    // const [qtServicos, setQTServicos] = useState(0); // total de serviços cadastrados
    // const [qtServicosAvulsos, setQTServicosAvulsos] = useState(0); // total de serviços cadastrados disponíveis pra agendamento avulso
    const navigate = useNavigate();

    // // const MySwalNovidades = withReactContent(Swal);
    // // Exemplo de dados de novidades
    // const novidades = [
    //     { id: 13, titulo: 'Correções',              subtitulo: '09-12-24: Quantidade de "Intervalo Atendimento"...', descricao:  'O "intervalo de Atendimento" estava gerando erro se no servidor não tivesse sido ainda cadastrado.' },
    //     { id: 12, titulo: 'Melhorias',              subtitulo: '06-12-24: Quantidade de dias que faltam...', descricao:  'Agora é exibida a mensagem da quantidade de dias que faltam para vencer o quantro, quando estiver faltando 5 dias ou menos.' },
    //     { id: 11, titulo: 'Correções',              subtitulo: '30-11-24: Descrição foi reintegrada aos agendamentos...', descricao:  'A descrição "nome do serviço" foi equivocadamente removida em versões anteriores. Nesta versão voltamos esta informação.' },
    //     { id: 10, titulo: 'Novidade',               subtitulo: '22-11-24: 3 Novas opções liberadas no botão "Opções"...', descricao: 'No menu "Agendamentos Abertos", o botão "Opções" possui 4 novas funcionalidades liberadas: "excluir" agendamento, "mudar status", "reenviar confirmação" de agendamento e "gerar recibo" em PDF para enviar para o cliente.' },
    //     { id: 9, titulo: 'Melhorias',               subtitulo: '15-11-24: Novo botão "Opções" em Agendamentos...', descricao: 'No menu "Agendamentos Abertos", substituímos o botão "excluir" pelo botão "opções" que agora o prestador pode realizar diversas ações, como: "mudar status", "excluir agendamento", etc, dentre outras ações que estarão em breve disponíveis.' },
    //     { id: 8, titulo: 'Melhorias',               subtitulo: '14-11-24: Prestador que trabalha sozinho...', descricao: 'Prestador que trabalha sozinho, não precisa mais criar colaboradores. Com essa melhoria melhora a experiência do consumidor final e diminui o tempo para realizar um agendamento.' },
    //     { id: 7, titulo: 'Novidade',                subtitulo: '09-11-24: Acrescentamos a opção "Intervalo de Atendimentos"...', descricao: 'Anteriormente o intervalo de um atendimento para outro era de 60 em 60 minutos. Agora, o prestador pode mudar entre 30/30 minutos até no máximo 120/120 minutos (2 horas).' },
    //     { id: 6, titulo: 'Atualização no Layout',   subtitulo: '09-11-24: Retiramos a opção de "TipoAtendimento"...', descricao: 'Foi removida esta opção que estava dentro do menu "empresa" e movida para dentro do menu "Regras".' },
    //     { id: 5, titulo: 'Melhorias',               subtitulo: '09-11-24: Melhoramos a interface do usuário...', descricao: 'Criamos o novo menu "Regras", onde novas opções foram criadas: "dias/horários" e "feriados". Todas as novas configurações estarão dentro deste menu.' },
    //     { id: 4, titulo: 'Novidade',                subtitulo: '08-11-24: Link Personalizado...',       descricao: 'A partir desta atualização, se o prestador trabalhar sozinho, não é necessário ele se cadastrar como "Colaborador", pois o sistema mostrará para o cliente ambas as opções, sem que o cliente saiba.' },
    //     { id: 3, titulo: 'Correções',               subtitulo: '29-10-24: Link Personalizado...',       descricao: 'O [link personalizado] não estava sendo exibido na tela "Empresa" mesmo se ele já estivesse sido cadastrado. Falha corrigida.' },
    //     { id: 2, titulo: 'Atualização no Layout',   subtitulo: '29-10-24: Foto do colaborador...',      descricao: 'A partir de agora, toda vez que você passar o seu link personalizado de agendamento para seu cliente, além do nome do colaboraedor, ele também verá a foto dele.' },
    //     { id: 1, titulo: 'Atualização no Layout',   subtitulo: '28-10-24: Melhoramos a interface...',   descricao: 'A página/menu "Serviços" tanto para alterar quanto para incluir novo serviço, o layout se ajusta de acordo com o tamanho da tela do celular, tablet, PC, etc.' },
    // ];

    // monitora o sistema se não há falhas ou fraudes
    useEffect(() => {
        const executarVerificacoes = async () => {
            if (userId !== 0 && userId !== undefined) {

                // Verifica se o email está validado
                const emailValidadoOk = await VerificaEmailValidado(userId, emailValidado);
                if (!emailValidadoOk) return;  // Se não está validado, não continua
    
                // // Verifica se a empresa está cadastrada
                // const empresaCadastradaOk = await VerificaSeEmpresaCadastrada(userId, indEmpresa);
                // if (!empresaCadastradaOk) return;  // Se não está cadastrada, não continua
    
                // // Verifica se o CPF/CNPJ está validado
                // const cpfCnpjValidadoOk = await VerificaSeCpfCnpjValidado(validado);
                // if (!cpfCnpjValidadoOk) return;  // Se não está validado, não continua

                // // Verifica se está vencendo pra renovar contrato ou contratar novo
                // const faltaMenosCincoDiasOk = await VerificaDiasFaltaVencerContrato(diasVencimentoContrato);
                // if (!faltaMenosCincoDiasOk) return;  // Se está bloqueada, não continua

                // // Verifica se a empresa está bloqueada
                // const empresaDesbloqueadaOk = await VerificaSeEmpresaBloqueada(lock);
                // if (!empresaDesbloqueadaOk) return;  // Se está bloqueada, não continua

                // const esconderNovidades = localStorage.getItem('esconderNovidades') === 'true';
                // if (!esconderNovidades || novidades.length > 0) {
                //     setMostrarNovidades(true);
                // }
            }
        };
    
        executarVerificacoes();
    }, [userId, emailValidado, validado]);
    // }, [userId, emailValidado, indEmpresa, lock, validado]);

    // const [mostrarNovidades, setMostrarNovidades] = useState(false);

    // //***** bloco todo levado pra dentro do  */
    // // // Verifica se deve exibir as novidades
    // // useEffect(() => {
    // //     const esconderNovidades = localStorage.getItem('esconderNovidades') === 'true';
    // //     if (!esconderNovidades || novidades.length > 0) {
    // //         setMostrarNovidades(true);
    // //     }
    // // }, []);

    // // Função para exibir o modal de novidades
    // const exibirNovidades = () => {
    //     MySwal.fire({
    //     // MySwalNovidades.fire({
    //         title: 'Novidades da Aplicação',
    //         html: (
    //             <div>
    //                 <ul style={{ listStyleType: 'none', padding: 0 }}>
    //                     {novidades.map((novidade) => (
    //                         <li key={novidade.id} style={{ marginBottom: '20px' }}>
    //                             <strong>{novidade.titulo}</strong>
    //                             <p>{novidade.subtitulo}</p>
    //                             <button
    //                                 onClick={() => abrirDescricaoNovidade(novidade.descricao)}
    //                                 style={{ border: 'none', background: 'none', color: 'blue', cursor: 'pointer' }}
    //                             >
    //                                 Ver mais
    //                             </button>
    //                         </li>
    //                     ))}
    //                 </ul>
    //                 <div>
    //                     <input
    //                         type="checkbox"
    //                         id="naoExibirNovamente"
    //                         onChange={(e) => localStorage.setItem('esconderNovidades', e.target.checked)}
    //                     />
    //                     <label htmlFor="naoExibirNovamente" style={{ marginLeft: '5px' }}>
    //                         Não exibir da próxima vez, exceto se houver novidades
    //                     </label>
    //                 </div>
    //             </div>
    //         ),
    //         showCloseButton: true,
    //         showConfirmButton: false,
    //         width: '600px',
    //     });
    // };

    // // Exibe a descrição completa da novidade ao clicar
    // const abrirDescricaoNovidade = (descricao) => {
    //     MySwal.fire({
    //     // MySwalNovidades.fire({
    //         title: 'Descrição da Novidade',
    //         text: descricao,
    //         icon: 'info',
    //         confirmButtonText: 'Fechar',
    //     });
    // };

    // // Exibe as novidades se necessário
    // useEffect(() => {
    //     if (mostrarNovidades) {
    //         exibirNovidades();
    //     }
    // }, [mostrarNovidades]);
    
    // Função para verificar se o email está validado
    const VerificaEmailValidado = async (userId, emailValidado) => {
        // if (emailValidado === 0) {
        if (emailValidado !== 1) {
            const result = await Swal.fire({
                title: 'Ativação da Conta',
                text: 'Para cadastrar sua empresa no AgendeX, você precisa validar seu email. Deseja validá-lo agora?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, validar!',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            if (result.isConfirmed) {
                carregaDados(userId); // Função para carregar dados e validar email
                return false; // Para o fluxo até a validação ser concluída
            } else {
                AutoLogout();
                return false; // Impede continuação
            }
        }
        return true; // Email validado, pode continuar
    };
    
    // // Função para verificar se a empresa está cadastrada
    // const VerificaSeEmpresaCadastrada = async (userId, indEmpresa) => {
    //     // if (indEmpresa === 0 || indEmpresa === null || indEmpresa === undefined) {
    //     if (indEmpresa !== 1) {
    //         const result = await Swal.fire({
    //             title: 'Cadastro Incompleto',
    //             text: 'Para continuar, você precisa completar os dados do seu Negócio/Empresa. Deseja continuar o cadastro agora?',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Sim, cadastrar!',
    //             cancelButtonText: 'Cancelar',
    //             allowOutsideClick: false,
    //             allowEscapeKey: false
    //         });
    
    //         if (result.isConfirmed) {
    //             if (userId) {
    //                 navigate('/app/prestador/perfil/cadastrarempresa', { 
    //                     state: { iduser: userId, indEmpresa: indEmpresa, from: '/app/prestador/home/' } 
    //                 });
    //             } else {
    //                 console.error("userId não definido");
    //             }
    //             return false; // Para impedir continuação
    //         } else {
    //             AutoLogout();
    //             return false; // Para impedir continuação
    //         }
    //     }
    //     return true; // Empresa cadastrada, pode continuar
    // };
    
    // // Função para verificar se a empresa está bloqueada
    // const VerificaSeEmpresaBloqueada = async (lock) => {
    //     if (lock !== 0) {
    //         const result = await Swal.fire({
    //             title: 'Cadastro Bloqueado',
    //             text: 'Para desbloquear sua conta, entre em contato com o Suporte Agendex. Deseja fazer logout agora?',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Sim, fazer logout!',
    //             cancelButtonText: 'Cancelar',
    //             allowOutsideClick: false,
    //             allowEscapeKey: false
    //         });
    //         if (result.isConfirmed) {
    //             localStorage.clear();
    //             navigate('/');
    //         } else {
    //             AutoLogout();
    //         }
    //         return false; // Empresa bloqueada, impede continuação
    //     }
    //     return true; // Empresa desbloqueada, pode continuar
    // };
    
    // // Função para verificar se o CPF/CNPJ está validado
    // const VerificaSeCpfCnpjValidado = async (validado) => {
    //     if (validado !== 1) {
    //         const result = await Swal.fire({
    //             title: 'Cadastro em Validação',
    //             text: 'Estamos agilizando a validação do seu cadastro. Deseja fazer logout agora?',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Sim, fazer logout!',
    //             cancelButtonText: 'Cancelar',
    //             allowOutsideClick: false,
    //             allowEscapeKey: false
    //         });
    //         if (result.isConfirmed) {
    //             localStorage.clear();
    //             navigate('/');
    //         } else {
    //             AutoLogout();
    //         }
    //         return false; // CPF/CNPJ não validado, impede continuação
    //     }
    //     return true; // CPF/CNPJ validado, pode continuar
    // };

    // // Função para verificar quantos dias que faltam pra encerrar o contrato
    // const VerificaDiasFaltaVencerContrato = async (dias) => {
    //     if (dias <= 5 && dias >=1 ) {
    //         const result = await Swal.fire({
    //             title: 'Contrato Finalizando',
    //             text: 'Faltam ' + dias + ' para o fim do seu contrato. Deseja entrar em contato com o suporte agora?',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Sim, fazer logout!',
    //             cancelButtonText: 'Agora não!',
    //             allowOutsideClick: false,
    //             allowEscapeKey: false
    //         });
    //         if (result.isConfirmed) {
    //             localStorage.clear();
    //             navigate('/');
    //         } else {
    //             // AutoLogout();
    //             return true; // pode continuar
    //         }
    //         return false; // impede continuação
    //     }
    //     return true; // pode continuar
    // };

    const { loading, setLoading, MySwal, carregaDados } = useCarregaDados();

    // useEffect(() => {
    //     if (userId) {
    //         carregaTotalServicos(userId, setQTServicos, setQTServicosAvulsos);
    //     }
    // }, [userId]);

    // const toggleAgendaStatus = async () => {
    //     const novoStatus = agendaFechada === 0 ? 1 : 0;
    //     setAgendaFechada(novoStatus);
    //     setLoading(true);
    //     try {
    //         // console.log(tokenASW);
    //         const response = await apiaxios.put('Usuario/AgendaFechadaWeb', {
    //             id_usuario: userId,
    //             // token: tokenASW,
    //             agenda_fechada: novoStatus
    //         }, {params: {id_usuario: userId, token: tokenASW}});
    
    //         if (response.status === 200 && response.data.retorno === 'OK') {
    //             // MySwal.fire('Status da Agenda', '"Status da Agenda" mudado com sucesso!', 'info');
    //             const mensagemStatus = novoStatus === 0 
    //                 ? '"Status da Agenda" mudado para "Aberta" com sucesso!' 
    //                 : '"Status da Agenda" mudado para "Fechada" com sucesso!';

    //             MySwal.fire('Status da Agenda', mensagemStatus, 'info');
                
    //             const encryptedToken = localStorage.getItem('tokenapw');
    //             const token = decrypt(encryptedToken);
    //             token.agenda_fechada = novoStatus;
    //             const updatedEncryptedToken = encrypt(token);
    //             localStorage.setItem('tokenapw', updatedEncryptedToken);
    //         } else {
    //             throw new Error(response.data.retorno || 'Falha ao carregar seus dados.');
    //         }
    //     } catch (error) {
    //         handleApiError(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    
    // // Função para alternar o tipo de agenda
    // const toggleTipoAgenda = async () => {
    //     Swal.fire('Tipo de Agenda', 'Opção indisponível na Web. Para modificar, baixe o App "Agendex Prestador" na "Google Play Store"', 'info');
    // };

    // // Função para fazer agendamento avulso
    // const toggleAgendaAvulso = async () => {
    //     Swal.fire('Agendamento Avulso', 'Opção indisponível na Web. Para realizar um agendamento avulso, baixe o App "Agendex Prestador" na "Google Play Store"', 'info');
    // };

    // // Função para alternar o tipo de atendimento
    // const toggleTipoAtendimento = async () => {
    //     Swal.fire('Tipo de Atendimento', 'Tome muito cuidado ao mudar esta opção que deve ser alterada no menu "Regras de Atendimento". Nela você informa se trabalha sozinho(a) ou com funcionário(s).', 'info');
    // };

    // const toggleServicos = async () => {
    //     navigate('/app/prestador/empresa/servicos');
    // };
    


    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page='home' />
                        </div>
                        <div className="col py-2 me-3">
                            <div className="text-center">
                                <h1>Home</h1>
                            </div>
                            <hr />

                            <MenuConfig id_usuario={userId} page="home"/>
                            <div className="container-fluid">
                                <Container>
                                    {/* Status da Agenda */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <h4>Status da Agenda</h4>
                                        <Button
                                            // variant={agendaFechada === 0 ? 'success' : 'secondary'}
                                            className="me-2"
                                            // onClick={toggleAgendaStatus}
                                        >
                                            Aberta
                                        </Button>
                                        <Button
                                            // variant={agendaFechada === 1 ? 'success' : 'secondary'}
                                            // onClick={toggleAgendaStatus}
                                        >
                                            Fechada
                                        </Button>
                                        </Col>
                                    </Row>
                                    <hr />

                                    {/* Tipo de Agenda */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <h4>Tipo de Agenda</h4>
                                        <Button
                                            // variant={tipoAgenda === 0 ? 'success' : 'secondary'}
                                            className="me-2"
                                            // onClick={toggleTipoAgenda}
                                        >
                                            Global
                                        </Button>
                                        <Button
                                            // variant={tipoAgenda === 1 ? 'success' : 'secondary'}
                                            // onClick={toggleTipoAgenda}
                                        >
                                            Individual
                                        </Button>
                                        </Col>
                                    </Row>
                                    <hr />

                                    {/* Tipo de Atendimento */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                            <h4>Tipo de Atendimento</h4>
                                            <Button
                                                // variant={tipoAtendimento === 1 ? 'success' : 'secondary'}
                                                // variant='success'
                                                className="me-2"
                                                // onClick={toggleTipoAtendimento}
                                            >
                                                {/* {tipoAtendimento === 0 ? 'Sem Colaborador' : 'Com Colaborador(es)'} */}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <hr />                                    

                                    {/* Botão "Serviços a Oferecer" */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className="btn-lg"
                                            // onClick={toggleServicos}
                                        >
                                            
                                            <div><h1>Serviços a Oferecer</h1></div>
                                            {/* <div>{qtServicos} Cadastrados</div> Esse valor xx será atualizado dinamicamente depois */}
                                        </Button>
                                        </Col>
                                    </Row>
                                    
                                    {/* Botão "Agendar Serviço Avulso" */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className=" btn-lg"
                                            // onClick={toggleAgendaAvulso}
                                        >
                                            <div><h1>Agendar Serviço Avulso</h1></div>
                                            {/* <div>{qtServicosAvulsos} Serviços disponíveis</div> Esse valor xx será atualizado dinamicamente depois */}
                                        </Button>
                                        </Col>
                                    </Row>

                                    {/* Botão "Agendamentos"
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className=" btn-lg">
                                            <div><h1>Agendamentos</h1></div>
                                            <div>xx Cadastrados</div> {/* Esse valor xx será atualizado dinamicamente depois //}
                                        </Button>
                                        </Col>
                                    </Row> */}
                                    
                                </Container>          
                                <div className="row">
                                    <div className={`row ${loading ? 'd-none' : ''}`}></div>
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default A_Home;